/**
 * Implements a news section placeholder
 */
import Skeleton from 'react-loading-skeleton';

const NewsPlaceholder = () => {
  return (
    <div className='seo_page__news'>
      <div className='seo_page__news__content'>
        <div className='seo_page__news__title'>
          <Skeleton width={90} height={24} />
        </div>
        <div className='seo_page__news__list'>
          <Skeleton
            width={312}
            height={112}
            count={3}
            inline
            style={{ marginRight: 12 }}
          />
        </div>
      </div>
    </div>
  );
};

export default NewsPlaceholder;
